import React, { useState } from 'react'
import { ChatWindow } from './chatWindow'
import { getRocketChatPinnedMessages, getRocketChatThreadMessages } from '../../../../api'
import { ThreadsSection } from '../threadsSecton/threadsSection'
import { SearchSection } from '../searchSection'

export const ChatSection = ({ channels, selectedChannel, containerRef, messages,
    threads, unredId, setSelectedThread, clientId, personId, firstUnreadRef, setThreads,
    threadsRef, ws, currentMessageRef, selectedThreadRef, loading, setShowParentThreads, selectedThread,
    showParentThreads, receipt, readReceipt, setReadReceipt, setMessages, markThreadRead,
    showPinnedMessages, setShowPinnedMessages, syncThreadsCount, fetchAllThreads, allParentThreads,
    loadingParentThreads, showParentThreadsRef, userAvatars, showSearchSection, setShowSearchSection, loadingNext,
    selectedMessageId, setSelectedMessageId, fetchAroundMessages, loadingPrev, userRole
}) => {

    const [loadngThreadReplies, setLoadingThreadReplies] = useState(false)
    const [pinnedMessages, setPinnedMessages] = useState([])
    const [loadingPinnedMessages, setLoadingPinnedMessages] = useState(false)

    const onClickViewAllThreads = () => {
        setShowPinnedMessages(false)
        setShowParentThreads(true)
        showParentThreadsRef.current = true
        fetchAllThreads()
    }

    const fetchThreadMessages = async (id) => {
        setLoadingThreadReplies(true)
        const res = await getRocketChatThreadMessages({
            personId: personId,
            threadId: id
        })
        if (res['messages']) {
            setThreads(res.messages)
            threadsRef.current = res.messages
        }
        setLoadingThreadReplies(false)
    }

    const onClickViewThread = (msg) => {
        setShowPinnedMessages(false)
        const newReadReceipt = readReceipt.map((receipt) => {
            if (receipt.rid === selectedChannel && receipt.tunread) {
                return {
                    ...receipt,
                    tunread: receipt.tunread.filter(id => id !== msg._id)
                }
            }
            return receipt
        })
        setReadReceipt(newReadReceipt)
        setSelectedThread(msg)
        selectedThreadRef.current = msg
        markThreadRead(msg._id)
    }

    const onClickShowPinnedMessages = async () => {
        setShowParentThreads(false)
        showParentThreadsRef.current = false
        setSelectedThread(null)
        setShowPinnedMessages(true)
        setLoadingPinnedMessages(true)
        const pinnedMessagesRes = await getRocketChatPinnedMessages({
            personId: personId,
            roomId: selectedChannel
        })
        if (pinnedMessagesRes['messages']) setPinnedMessages(pinnedMessagesRes['messages'])
        setLoadingPinnedMessages(false)
    }

    return (
        <>
            <div className='right-container'>
                <ChatWindow
                    channels={channels}
                    selectedChannel={selectedChannel}
                    containerRef={containerRef}
                    messages={messages.filter((msg) => (!msg.t || msg.t !== 'au') && !msg.tmid && (msg.t !== 'message_pinned'))}
                    unredId={unredId}
                    threads={threads}
                    setSelectedThread={setSelectedThread}
                    clientId={clientId}
                    personId={personId}
                    firstUnreadRef={firstUnreadRef}
                    setThreads={setThreads}
                    threadsRef={threadsRef}
                    ws={ws}
                    currentMessageRef={currentMessageRef}
                    selectedThreadRef={selectedThreadRef}
                    loading={loading}
                    loadingNext={loadingNext}
                    loadingPrev={loadingPrev}
                    onClickViewAllThreads={onClickViewAllThreads}
                    receipt={receipt}
                    fetchThreadMessages={fetchThreadMessages}
                    loadngThreadReplies={loadngThreadReplies}
                    onClickViewThread={onClickViewThread}
                    showPinnedMessages={showPinnedMessages}
                    setShowPinnedMessages={setShowPinnedMessages}
                    setMessages={setMessages}
                    onClickShowPinnedMessages={onClickShowPinnedMessages}
                    syncThreadsCount={syncThreadsCount}
                    userAvatars={userAvatars}
                    setShowSearchSection={setShowSearchSection}
                    selectedMessageId={selectedMessageId}
                    userRole={userRole}
                />
            </div>
            {(selectedThread) ? (
                <div className='rightmost-container right-container'>
                    <ChatWindow
                        channels={channels}
                        selectedChannel={selectedChannel}
                        containerRef={containerRef}
                        messages={threads ? [selectedThread, ...threads] : []}
                        unredId={unredId}
                        threads={threads}
                        setSelectedThread={setSelectedThread}
                        clientId={clientId}
                        personId={personId}
                        isThreadsWindow={true}
                        selectedThread={selectedThread}
                        firstUnreadRef={firstUnreadRef}
                        setThreads={setThreads}
                        threadsRef={threadsRef}
                        ws={ws}
                        currentMessageRef={currentMessageRef}
                        selectedThreadRef={selectedThreadRef}
                        loading={loading}
                        loadingNext={loadingNext}
                        loadingPrev={loadingPrev}
                        onClickViewAllThreads={onClickViewAllThreads}
                        receipt={receipt}
                        fetchThreadMessages={fetchThreadMessages}
                        loadngThreadReplies={loadngThreadReplies}
                        onClickViewThread={onClickViewThread}
                        showPinnedMessages={showPinnedMessages}
                        setShowPinnedMessages={setShowPinnedMessages}
                        setMessages={setMessages}
                        syncThreadsCount={syncThreadsCount}
                        userAvatars={userAvatars}
                        selectedMessageId={selectedMessageId}
                    />
                </div>
            ) : (showParentThreads ? (
                <div className='rightmost-container right-container'>
                    <ThreadsSection
                        list={allParentThreads}
                        containerRef={containerRef}
                        loading={loadingParentThreads}
                        setShowParentThreads={setShowParentThreads}
                        showParentThreadsRef={showParentThreadsRef}
                        fetchThreadMessages={fetchThreadMessages}
                        setSelectedThread={setSelectedThread}
                        receipt={receipt}
                        onClickViewThread={onClickViewThread}
                        selectedThreadRef={selectedThreadRef}
                        userAvatars={userAvatars}
                    />
                </div>
            ) : (<></>))}
            {showPinnedMessages ? (
                <div className='rightmost-container right-container'>
                    <ThreadsSection
                        list={pinnedMessages}
                        containerRef={containerRef}
                        loading={loadingPinnedMessages}
                        setShowParentThreads={setShowPinnedMessages}
                        showParentThreadsRef={showParentThreadsRef}
                        fetchThreadMessages={fetchThreadMessages}
                        setSelectedThread={setSelectedThread}
                        receipt={receipt}
                        onClickViewThread={onClickViewThread}
                        selectedThreadRef={selectedThreadRef}
                        isPinnedMessagesSection={true}
                        userAvatars={userAvatars}
                    />
                </div>
            ) : (<></>)}
            {(showSearchSection && !selectedThread) ? (
                <div className='rightmost-container right-container'>
                    <SearchSection
                        setShowSearchSection={setShowSearchSection}
                        userAvatars={userAvatars}
                        selectedChannel={selectedChannel}
                        personId={personId}
                        setSelectedThread={setSelectedThread}
                        setSelectedMessageId={setSelectedMessageId}
                        messages={messages}
                        fetchAroundMessages={fetchAroundMessages}
                        setMessages={setMessages}
                    />
                </div>
            ) : (<></>)}
        </>
    )
}
